import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="page-header" className="relative flex min-h-[45vh] flex-col items-center justify-center overflow-hidden bg-secondary py-20 md:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/oem_nameplates_consistency_bg.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/oem_nameplates_consistency_bg.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/oem_nameplates_consistency_bg.webp-wvc-sizes" alt="OEM nameplate supplier — recurring equipment nameplate and data plate programs by Evermark Industrial Solutions" className="h-full w-full object-cover opacity-30 mix-blend-overlay" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/90 via-secondary/80 to-background/95" />
      </div>

      <div className="container relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 text-center">
        {}
        <div className="mb-8 flex justify-center">
          <Breadcrumb>
            <BreadcrumbList className="text-primary/80 sm:gap-2">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="hover:text-primary">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-primary/60" />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/IndustriesPage" className="hover:text-primary">Industries</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-primary/60" />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-primary font-medium">OEM Equipment Manufacturers</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <span className="mb-4 block text-sm font-bold tracking-widest uppercase text-primary">FOR ORIGINAL EQUIPMENT MANUFACTURERS</span>

        {}
        <h1 className="mb-6 font-default text-4xl font-bold leading-tight text-accent md:text-5xl lg:text-6xl">
          OEM Nameplate Supplier — Recurring Nameplate, Data Plate & DPM Programs
        </h1>

        {}
        <p className="mb-10 max-w-3xl text-lg leading-relaxed text-foreground md:text-xl">
          Evermark Industrial Solutions is a recurring marking supplier for OEM equipment manufacturers — nameplates, data plates, and direct part marking delivered to one approved format, run after run, integrated with your production schedule. Set up a program once and reorder to the same spec every build.
        </p>

        {}
        <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link to="/ContactPage">Contact Us </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground sm:w-auto dark:border-primary dark:text-primary dark:hover:bg-primary dark:hover:text-primary-foreground">
            
          </Button>
        </div>
      </div>
    </section>;
}